import { create } from 'zustand';

const useModalStore = create((set) => ({
  show: false,
  title: '',
  content: '',
  buttonText: '',
  gradientHeader: false,
  dense: false,
  dialogClassName: '',
  buttonCallback: () => {},
  openModal: ({ title = '', content = '', buttonText = '', buttonCallback = () => {}, gradientHeader = false, dense = false, dialogClassName = '' }) =>
    set({ show: true, title, content, buttonText, buttonCallback, gradientHeader, dense, dialogClassName }),
  closeModal: () =>
    set({ show: false }),
}));

export default useModalStore;
